<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/specialWork/add')">新增申请</el-button>
      </template>

      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width"
        label-width="100px"
      >
        <el-form-item label="作业票编号" prop="ticketNo">
          <el-input v-model.trim="searchForm.ticketNo" clearable placeholder="作业票编号"/>
        </el-form-item>
        <el-form-item label="作业类型" prop="workType">
          <el-select v-model="searchForm.workType" clearable>
            <el-option
              v-for="(label, value) in workTypes"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="ticketStatus">
          <el-select v-model="searchForm.ticketStatus" clearable>
            <el-option
              v-for="(label, value) in statuses"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人" prop="applicantName">
          <el-input v-model.trim="searchForm.applicantName" clearable placeholder="申请人"/>
        </el-form-item>
        <el-form-item label="联系电话" prop="applicantMobile">
          <el-input v-model.trim="searchForm.applicantMobile" clearable placeholder="联系电话"/>
        </el-form-item>
        <el-form-item label="所属部门" prop="departmentName">
          <el-input v-model.trim="searchForm.departmentName" clearable placeholder="所属部门"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table
        size="mini"
        stripe
        border
        v-loading="loading"
        :data="rows"
      >
        <el-table-column min-width="210" show-overflow-tooltip label="作业票编号" prop="ticketNo"/>
        <el-table-column min-width="100" show-overflow-tooltip label="类型">
          <template v-slot="{ row }">
            {{ workTypes[row.workType] }}
          </template>
        </el-table-column>
        <el-table-column min-width="165" show-overflow-tooltip label="状态">
          <template v-slot="{ row }">
            <el-tag :type="getTagType(row.ticketStatus)">
              {{ statuses[row.ticketStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-for="field in listFields"
          :key="field[0]"
          min-width="130"
          show-overflow-tooltip
          :label="field[1]"
          :prop="field[0]"
        />
        <el-table-column min-width="165" show-overflow-tooltip label="计划开始时间" prop="startTime"/>
        <el-table-column min-width="165" show-overflow-tooltip label="计划结束时间" prop="endTime"/>
        <el-table-column width="200" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button v-for="action in availableActions(row.ticketStatus)" :key="action" type="text"
                       :class="action === 'REJECT' ? 'del-btn' : ''" @click="openProcess(action, row)">{{ actions[action] }}</el-button>
            <el-button type="text" @click="detail(row)">详情</el-button>
            <el-button
              type="text"
              class="del-btn"
              v-if="hasDelete && row.ticketStatus === '1'"
              @click="remove(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="actions[form.action]" :visible.sync="dialogVisible" width="760px" :close-on-click-modal="false" :before-close="closeProcess">
      <el-form ref="processForm" :model="form" label-width="150px" :disabled="saving">
        <template v-if="form.action === 'SAFETY'">
          <el-alert title="可先提交风险辨识和安全措施，安环签字可在流程结束前补录。" type="info" :closable="false" class="mb15" />
          <el-form-item v-for="field in safetyFields" :key="field[0]" :label="field[1]" :prop="field[0]" :rules="requiredSafety.includes(field[0]) ? [{ required: true, whitespace: true, message: '请填写' + field[1], trigger: 'blur' }] : []">
            <el-input v-model.trim="form[field[0]]" type="textarea" :rows="2" :maxlength="field[0] === 'riskLevel' ? 20 : field[0].includes('Concentration') ? 100 : 1000" />
          </el-form-item>
          <el-form-item label="风险及现场照片"><file-upload v-model="form.riskFiles" :update="false" /></el-form-item>
        </template>
        <el-form-item v-if="form.action === 'ACCEPTANCE'" label="完工验收照片" prop="acceptanceFiles" :rules="fileRule('请上传完工验收照片')"><file-upload v-model="form.acceptanceFiles" :update="false" accept=".png,.jpg,.jpeg" /></el-form-item>
        <el-form-item v-if="signatureField" :key="signatureField" :label="form.action === 'SAFETY' ? '安环签字（可补录）' : '本人签字'" :prop="signatureField" :rules="form.action === 'SAFETY' ? [] : fileRule('请上传本人签字')">
          <file-upload v-model="form[signatureField]" :update="false" accept=".png,.jpg,.jpeg" :limit="1" :multiple="false"><template #tip><div>请上传本人手写签名图片。</div></template></file-upload>
        </el-form-item>
        <el-form-item :label="form.action === 'REJECT' ? '驳回原因' : '处理意见'" prop="processComments" :rules="form.action === 'REJECT' ? [{ required: true, whitespace: true, message: '请填写驳回原因', trigger: 'blur' }] : []">
          <el-input v-model.trim="form.processComments" type="textarea" :rows="3" maxlength="1000" />
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="submit">确认提交</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { workTypes, statuses, baseFields, safetyFields, attachmentFields, actions } from './fields'

// 安环必填内容与服务端校验保持一致，浓度和风险等级不擅自增加枚举限制。
const requiredSafety = ['riskAnalysis', 'equipmentIsolationMeasures', 'siteGuardianMeasures', 'personalProtectionMeasures', 'emergencyMeasures']
const signatureByAction = { SAFETY: 'safetySignature', SAFETY_SIGN: 'safetySignature', LEADER: 'leaderSignature', PRINCIPAL: 'principalSignature', ACCEPTANCE: 'acceptanceSignature' }

export default {
  name: 'SpecialWorkList',
  data() {
    return {
      workTypes,
      statuses,
      listFields: baseFields.filter(field => field[0] !== 'workContent'),
      page: 1,
      total: 0,
      rows: [],
      loading: false,
      requestId: 0,
      searchForm: {
        ticketNo: '',
        workType: '',
        ticketStatus: '',
        applicantName: '',
        applicantMobile: '',
        departmentName: ''
      },
      dialogVisible: false,
      saving: false,
      form: {},
      safetyFields,
      attachmentFields,
      requiredSafety,
      actions
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasLeader() {
      return this.buttonList.includes('leader')
    },
    hasPrincipal() {
      return this.buttonList.includes('principal')
    },
    hasReject() {
      return this.buttonList.includes('reject')
    },
    hasSafety() {
      return this.buttonList.includes('safety')
    },
    hasSafetySign() {
      return this.buttonList.includes('safetySign')
    },
    hasAcceptance() {
      return this.buttonList.includes('acceptance')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    signatureField() {
      return signatureByAction[this.form.action]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    getTagType(status) {
      if (status === '6') return 'danger'
      if (status === '5') return 'success'
      return 'warning'
    },
    buildSearchParams() {
      return {
        ...this.searchForm
      }
    },
    async loadData() {
      const requestId = ++this.requestId
      this.loading = true
      const params = {
        page: this.page,
        size: 10,
        ...this.buildSearchParams()
      }
      try {
        const result = await this.$axios.get(this.$apis.specialWork.list, params)
        if (requestId === this.requestId) {
          this.rows = result.list || []
          this.total = result.total || 0
        }
      } catch (error) {
        if (requestId === this.requestId) {
          this.rows = []
          this.total = 0
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false
        }
      }
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
      this.onSearch()
    },
    // 按当前状态和固定责任人显示动作，服务端仍承担最终身份和状态校验。
    availableActions(status) {
      if (['5', '6'].includes(status)) return []
      const list = []
      if (status === '1' && this.hasSafety) list.push('SAFETY')
      if (status === '2' && this.hasLeader) list.push('LEADER')
      if (status === '3' && this.hasPrincipal) list.push('PRINCIPAL')
      if (status === '4' && this.hasAcceptance) list.push('ACCEPTANCE')
      if (['2', '3', '4'].includes(status) && this.hasSafetySign) list.push('SAFETY_SIGN')
      if (this.hasReject) list.push('REJECT')
      return list
    },
    detail(row) {
      this.$router.push({
        path: '/specialWork/detail',
        query: {
          ticketId: row.ticketId
        }
      })
    },
    async remove(row) {
      try {
        await this.$confirm('确认永久删除该作业票及其附件关系？', '删除确认', {
          type: 'warning'
        })
        await this.$axios.post(this.$apis.specialWork.remove, {
          ticketId: row.ticketId
        })
        if (this.rows.length === 1 && this.page > 1) {
          this.page--
        }
        await this.loadData()
      } catch (error) {
        // 取消弹窗 / 请求失败，交由全局拦截器提示
      }
    },

    closeProcess(done) { if (!this.saving) done() },
    // 每次打开使用独立表单，只发送本节点字段，避免修改详情里的其他业务信息。
    openProcess(action, row) {
      const form = { ticketId: row.ticketId, action, processComments: '' }
      if (action === 'SAFETY') {
        safetyFields.forEach(([key]) => { form[key] = row[key] || '' })
        form.riskFiles = [...(row.riskFiles || [])]
      }
      if (signatureByAction[action]) form[signatureByAction[action]] = []
      if (action === 'ACCEPTANCE') form.acceptanceFiles = []
      this.form = form
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.processForm.clearValidate())
    },
    async submit() {
      if (this.saving) return
      const valid = await this.$refs.processForm.validate().catch(() => false)
      if (!valid) return
      this.saving = true
      try {
        await this.$axios.post(this.$apis.specialWork.process, this.form)
        this.dialogVisible = false
        await this.loadData()
      } catch (error) { /* 保留本次输入，公共拦截器展示状态冲突或身份校验错误。 */ } finally { this.saving = false }
    }
  }
}
</script>

<style scoped lang='scss'>

</style>
